const MIN_PROMPT_CONFIRMATION_DAYS = 2;
const MAX_PROMPT_CONFIRMATION_DAYS = 20;

const buildPromptConfirmationDayOptions = (minDays: number, maxDays: number) =>
  Array.from({ length: maxDays - minDays + 1 }, (_, index) => {
    const day = minDays + index;
    return { value: day, label: String(day) };
  });

export const driverConfirmationConstants = {
  MIN_PROMPT_CONFIRMATION_DAYS,
  MAX_PROMPT_CONFIRMATION_DAYS,
  DEFAULT_PROMPT_CONFIRMATION_DAYS: 14,
  MAX_CONFIRMATION_DISPLAY_RANGE_DAYS: 14,
  promptConfirmationDayOptions: buildPromptConfirmationDayOptions(
    MIN_PROMPT_CONFIRMATION_DAYS,
    MAX_PROMPT_CONFIRMATION_DAYS,
  ),
  LABEL: {
    DRIVER_CONFIRMATION_REQUIRED: 'Driver Confirmation Required?',
    DRIVER_CONFIRMATION_HELPER:
      "The driver will be asked to confirm holiday dates at the customer's location.",
    PROMPT_CONFIRMATION: 'Prompt confirmation',
    PROMPT_CONFIRMATION_SUFFIX: 'days before the holiday',
    CONFIRMATION_DISPLAY_RANGE: 'Confirmation display range (days)'
  },
  MESSAGE: {
    CONFIRMATION_DISPLAY_RANGE_REQUIRED: '* Required',
    CONFIRMATION_DISPLAY_RANGE_MAX_DAYS: 'Confirmation display range cannot exceed 14 days.',
    HOLIDAY_DATE_OUTSIDE_CONFIRMATION_RANGE:
      'Holiday date must be within the confirmation range.',
    COMPANY_HOLIDAY_CONFIRMATION_DISABLED:
      'Driver confirmation is not available for company holidays.'
  }
};
